import { render, staticRenderFns } from "./ModuloCFE.vue?vue&type=template&id=0309c40a"
import script from "./ModuloCFE.vue?vue&type=script&lang=js"
export * from "./ModuloCFE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports